import React, {useContext} from 'react';
import {translate} from '../../helpers/base';
import {AppContext} from '../../contexts/AppContext';

const Pets = () => {
    const {
        selectedFilters,
        handleSimpleFilterChange,
    } = useContext(AppContext);

    return (
        <div className="checkbox">
            <label>
                <input
                    type="checkbox"
                    checked={selectedFilters.petsAllowed ?? false}
                    onChange={() => handleSimpleFilterChange('petsAllowed', !selectedFilters.petsAllowed)}
                />
                <span></span>
                <div>{translate('accommodation-overview.filter.misc.petsAllowed')}</div>
            </label>
        </div>
    );
};

export default Pets;